import { IconHome01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  /** onClick */
  onClick?: () => void;
}

const ModalHomeBtn = ({ onClick }: IProps) => (
  <S.ModalHomeBtn
    className="btn-home"
    label="홈"
    icon={<IconHome01 />}
    onClick={onClick}
  />
);

export default ModalHomeBtn;
